const lang = {
    // Drawer
    logOut: "Log Out",
    Account: "Account",
    english: "English",
    french: "French",
    Organization: "Organization",
    language: "Language",
    manageAccount: "Manage your account",
    Warning: "Warning",
    skip: "Skip",
    useDefault: "Use default",
    reset: "Reset",
    ALL: "ALL",
    ANY: "ANY",
    dropYourFiles: "Drop your files here",
    toggleTheme: "Dark mode",
    rename: "Rename",
    Settings: "Settings",
    deconnection: "Deconnection",
    areYouLeaving: "Are you leaving ?",
    Avatar: "Avatar",

    new: "New",
    X: "x",

    Failed: "Failed",
    NetworkError: "Network error",
    NetworkErrors: "Network errors",
    NotAnswered: "Not answered",
    IntercomOnBreak: "Intercom on break",
    NoAvailableIntercom: "No available Intercom",
    NotSpecified: "Not specified",
    Treaty: "Treaty",
    SwitchToContinuousMode: "Switch to continous mode",
    ChoosingTheCapsuleToTarget: "Choosing the capsule to target",
    SessionAlreadyInProgress: "Session already in progress",
    lockedIntercom: "Votre Intercom est actuellement utilisé par un autre utilisateur. Vous pouvez déconnecter l’utilisateur en cours et reprendre le contrôle sur l’Intercom.",
    usedIntercom: "Intercom utilisé",
    TextSessionAlreadyInProgress: "It looks like you're already logged in on another machine. You must log out of the current session before you can start a new session.",
    MessageConfirmDeconnection: "By confirming your disconnection, you will immediately interrupt communication with the capsule.",
    AttentionCallInProgress: "Attention, an appeal is in progress : ",
    IntercomLinked: "Intercom linked",
    Disconnected: "Disconnected",
    UsedBy: "Used by",
    You: "You",
    WrongExtension: "Mauvaise extension",
    TextWrongExtension: "Pour des raisons de sécurité, vous ne pouvez pas charger de fichiers de type .",

    //NavMenu
    tools: "Tools",
    gestion: "Gestion",
    profil: "Profil",
    dashboardFullView: "Vue d'ensemble",
    dashboard: "Dashboard",
    dashboardAgents: "Par Intercom",
    dashboardClients: "Par Origine",
    callLink: "Link Call",
    alertDiffusion: "Alerts diffusion",
    portals: "Portals",
    usersAndRoles: "Users and Roles",
    superAdmin: "Super Admin",
    organisation: "Organisation",
    Permanent: "Permanents",
    Instant: "Instant",
    ClientsRecall: "Clients Reminders",

    // Pairing Intercom
    PairingIntercom: "PairingIntercom",
    PairingImpossible: "Pairing impossible",
    EnterPairingCodeDisplayedOnIntercom: "Enter the pairing code displayed on the intercom:",
    ConfirmPairing: "Confirm the association",
    boldTextIntercomAlreadyPaired: "The selected intercom is being used by another user. ",
    TextIntercomAlreadyPaired: "Do you want to disconnect this user to continue the association?",
    IntercomAlreadyPaired: "Intercom already paired",
    boldTextIntercomDisconnected: "Unable to reach the intercom: it is disconnected. ",
    TextIntercomDisconnected: "Check that it is switched on and connected to the network or restart the pairing with another intercom.",
    boldTextIntercomUnauthorized: "The selected intercom is not linked to your Call Center. ",
    TextIntercomUnauthorized: "Please try pairing again with a different intercom.",
    boldTextIntercomNotFound: "The association code entered is invalid. ",
    TextIntercomNotFound: "Check it and try the pairing again.",
    lastPairing: "last association",
    OtherIntercom: "Other intercom",

    //General settings
    generalSettings: "General Settings",
    Attributes: "Attributes",
    Behaviors: "Behaviour",
    ShowQRCode: "Show QR code",
    MuteVideos: "Mute all videos",
    Files: "Files",
    addFile: "Add a file",
    myPOI: "My POI",
    deleteConfirm: "Delete ?",

    // Release note
    gotIt: "got it",
    versionReleaseNote: "SkaLink version",
    releaseNote: "Release note",
    bugsFixe: "ENHANCEMENTS",
    newInVersion: "NEW IN THIS VERSION",
    versionNote: "Version note",

    // Buttons
    clear: "Clear",
    addBlock: "Add a block",
    addModule: "Add a module",
    addButton: "Add",
    cancelButton: "CANCEL",
    okButton: "OK",
    Validate: "Validate",
    CSVButton: "CSV",
    PDFButton: "PDF",
    PNGButton: "PNG",
    register: "Save",
    downloadSource: "Ouvrir la source",
    Capture: "Capture",
    Save: "Save",
    SaveChanges: "Save changes",
    saving: "Saving",
    saved: "saved!",
    sendInvitation: "Send invitation",
    resendInvitation: "Send again invitation",
    confirmButton: "Confirm",
    addAll: "Add All",
    selectButton: "Select",
    replaceButton: "Replace",
    refreshButton: "Refresh",
    browse: "Browse...",
    return: "Return",
    Send: "Send",
    Loading: "Loading...",
    PermanentlyEndTheCall: "Permanently end the call",
    Retry: "Retry",
    TakeControl: "Prendre le contrôle de l'intercom",
    Start: "Start",
    Download: "Download",
    Activate: "Activate",
    ToEnd: "To end",
    Mac: "Mac",
    Windows: "Windows",
    Restart: "Restart",
    ToContinue: "To continue",

    // Content groups actions
    cgDeleted: "Content Group deleted",
    cgSaved: "Content Group saved",

    // User groups actions
    ugDeleted: "User Group deleted",
    ugSaved: "User Group saved",
    ListUserGroups: "List of user groups",
    addUserGroupe: "Add User Group",
    uSaved: "Changes to user saved",

    // Compositions actions
    compDeleted: "Composition deleted",
    compSaved: "Composition successfully saved",
    compDuplicated: "New composition created",
    chooseComposition: "Choose a Composition",

    // Contents actions
    contentDeleted: "Content deleted",
    contentSaved: "Content successfully saved",
    contentDuplicated: "New content created",

    // Playlists actions
    playlistDeleted: "Playlist deleted",
    playlistSaved: "Playlist successfully saved",
    playlistDuplicated: "New composition created",
    chooseplaylist: "Choose a playlist",

    // Schedules actions
    scheduleDeleted: "Schedule deleted",
    scheduleSaved: "Schedule successfully saved",
    scheduleDuplicated: "New schedule created",

    // Data sources actions
    dsDeleted: "Data source deleted",
    dsSaved: "Data source successfully saved",
    dsDuplicated: "New data source created",

    // Deployments actions
    deploySuccess: "Deploy successful",
    deployInProgress: "Deployment in progress, this may take a while.",

    // Commands to player actions
    messageSent: "Message sent to display",

    // Display groups actions
    dgDeleted: "Decision tree deleted",
    dgSaved: "Decision tree saved",
    addDisplayGroup: "Add Decision tree",
    dgList: "Decision trees list",

    // Call center actions
    ccDeleted: "Call center deleted",
    ccSaved: "Call center saved",

    // Display actions
    displayDeleted: "Screen deleted",
    displaySaved: "Screen saved",
    confirmDeleteDisplay: "Delete this screen?",
    confirmDeleteDisplayGroup: "Delete this screen group?",

    // Styles actions
    styleDeleted: "Style deleted",
    styleSaved: "Style successfully saved",

    // SuperAdmin actions
    orgEnabled: "Organization enabled",
    orgDisabled: "Organization disabled",
    orgCreated: "Organization created",

    // Tags actions
    tagsComposition: "composition",
    tagsContent: "content",
    tagsPlaylist: "playlist",
    tagsSchedule: "schedule",
    tagsStyle: "style",
    tagsBasic: "Basic",
    tagsAdvanced: "Advanced",

    // Color
    inherited: "inherited",
    select: "Select",

    // ModuleEditor
    newMenuEntry: "New Menu entry",
    moduleEdition: "Module edition",
    module: "Module",
    newModule: "New module",
    inheritStartScreen: "Inherit from start screen",
    inheritFrom: "Inherit from",
    moduleType: "Module type",
    Type: "Type",
    mode: "Mode",
    TwitterUserName: "Username",
    moduleData: "Module data",
    feedUrl: "Feed URL",
    addURLToResource: "Ajouter ce lien web aux Ressources",
    mapCenterPoint: "Map center point",
    longitude: "Longitude",
    moduleContent: "Module content",
    moduleCover: "Module cover",
    moduleHero: "Module hero",

    // ContentGroupList
    contentGroup: "Content group",
    selectcontentGroup: "Select Content Group",
    chooseContentGroup: "Choose content group",
    cancel: "Cancel",
    cancelSuccess: "Deployment cancelled",
    chooseContent: "Choose Content",
    confirmDeleteContentGroup: "Delete this Content Group?",

    // ContentListCard
    contentEdit: "Edit",
    contentDelete: "Delete",
    contentAdd: "Add",
    contentDuplicate: "Duplicate",
    contentReplace: "replace selected content",

    // DataSourceList
    dataSource: "Data Source",
    noDataSource: "no Data Source",
    noDataSourceSelected: "No data source selected",
    chooseDataSource: "Choose data source",

    // Content Library -> New Content
    newContentDataSources: "Data Sources",
    descriptionDataSources: "These modules are available in the CONNECT section",
    newContentOtherModules: "Other modules",
    descriptionOtherModules: "These modules are directly available when editing your compositions under the tabs \"Layout\" and \"Nav Bar\"",

    // EditItemStyle
    EditStyle: "Edit Style",
    importStyle: "Import Style",
    chooseStyle: "Choose a Style",

    //ItemTypes
    col1Title: "IMAGE & VIDEO",
    col2Title: "SOCIAL",
    col3Title: "COMMON",
    col4Title: "TEXT",
    col5Title: "COMMUTING",
    col6Title: "WEB CONTENT",

    createNewContentDialog: "New ",
    onlyInLux: "Made for Luxembourg !",

    bannerTitle: "Text banner",
    bannerDescription: "Display text in a scrolling banner",
    busTitle: "Bus stops (Lux)",
    busDescription: "Display the bus timetable for a given stop",
    citaTitle: "Cita",
    citaDescription: "Display one of the camera streams proposed by CITA",
    clockTitle: "Clock",
    clockDescription: "Display a digital clock, choosing between different date and time formats",
    facebookTitle: "Facebook",
    facebookDescription: "Display one of your Facebook accounts content",
    tableTitle: "Table",
    tableDescription: "Display rows and columns of text",
    MediaGalleryTitle: "Media gallery",
    MediaGalleryDescription: "Gallery made of images and/or videos that can be displayed in full size.",
    rssTitle: "RSS feed",
    rssDescription: "Display the content of a RSS feed in a scrolling banner",
    textTitle: "Text block",
    textDescription: "Display a block of well formatted text",
    twitterTitle: "X (Twitter)",
    twitterDescription: "Display your latest posts on your start screen. Automatic refresh.",
    youtubeTitle: "YouTube",
    youtubeDescription: "Display a YouTube video stream",
    weatherTitle: "Weather",
    weatherDescription: "Display daily or weekly weather forecast for a given place",
    webTitle: "Web URL",
    webDescription: "Display the content of an existing web site",
    imageTitle: "Photo",
    imageDescription: "The simplest way to display a single picture in full screen.",
    videoTitle: "Video",
    videoDescription: "Play your video content. Including player controls.",
    htmlTitle: "HTML content",
    htmlDescription: "Upload and display your own HTML-CSS content",
    instagramTitle: "Instagram",
    instagramDescription: "Display one of your Instagram accounts content",
    pdfTitle: "PDF",
    pdfDescription: "Publish single or multipage documents to read and/or download.",
    AdsTitle: "Ads",
    AdsDescription: "Post your classified ads with photos, organized by category.",
    FlipCardTitle: "Flip Card",
    FlipCardDescription: "A two-sided card (front/back) that flips over when the user clicks on it.",
    MemoryGameTitle: "Game · Memory",
    MemoryGameDescription: "The famous game where you have to find pairs of identical cards!",
    surveyTitle: "Survey / Quizz",
    surveyDescription: "Gather feedback from you staff and/or assess their knowledge on a topic.",
    itineraryTitle: "Itinerary",
    itineraryDescription: "Take a look at the traffic and estimate the travel time from point A to point B.",
    jaliosAgendaTitle: "Jalios · Agenda",
    jaliosAgendaDescription: "From your intranet: events with their full description & QR Code for registration.",
    jaliosCarouselTitle: "Jalios · Carousel",
    jaliosCarouselDescription: "From your intranet: gallery of images and/or videos for your start screen hero.",
    supermiroTitle: "Supermiro le Club",
    supermiroDescription: "The latest experiences from Supermiro le Club, displayed on your start screen.",
    newsFeedTitle: "News feed",
    newsFeedDescription: "Real-time news feed from the media of your choice.",
    restaurantMenuTitle: "Restaurant menu",
    restaurantMenuDescription: "Display the menu of your company restaurant. Automatically updated.",
    jobBoardTitle: "Job board",
    jobBoardDescription: "Post your job offers, classified by category.",

    // EditItemTop
    contentName: "Name",
    save: "Save",
    delete: "Delete",
    close: "Close",
    mustHaveName: "This asset must have a name.",
    mustHaveTitleLang: "This asset must have a Title.",
    changeContentGroup: "Change content group",
    mustHaveContentGroup: "This asset must have a content group.",
    ContentsList: "Edit Content",
    preview: "Preview",
    styles: "Select the style to use with this preview.",
    closing: "Closing",
    SaveCheck: "Do you wish to save your work ?",
    yes: "Yes",
    no: "No",
    mustBeNamed: "the element must be named",

    // EditTags
    tags: "Tags",
    existingtags: "Existing tags",
    newTag: "New tag...",
    myNewTag: "My new tag",
    tagsList: "Tags list",
    label: "Tag",
    addTag: "Add Tag",
    chooseTag: "Choose tag",
    mustSave: "You must save before adding Tags.",
    assignTags: "Assign the following tags",
    and: "and",
    or: "or",

    // EditTags
    tagsSelection: "Show only items containing these tags ",
    moreTag: "Tags(+)",
    startSearch: "Validate",

    // TextFontsList
    font: "Font",
    palette: "Palette",
    Fonts: "Fonts",
    Palettes: "Color palette",

    // TextFontSize
    auto: "Automatic (size to fit)",

    // ErrorBoundary
    errorDevNotified: "An unexpected error occured. Developers have been notified",

    // Loader
    loadingComponents: "Loading components",

    // AllDisplayMonitorView
    displayGroup: "Display group : ",
    displayScreen: "Display screenshot",
    monitorDisplay: "Monitor display",

    // Status
    unknown: "Unknown",

    // NavMenu
    ContentLibrary: "Resources",
    Composition: "Compositions",
    Playlists: "Playlists",
    Schedules: "Schedule & Deploy",
    Monitoring: "Monitor",
    Administration: "Users Management",
    UsersList: "Users",
    InvitationsList: "Invitations",
    UserGroupsList: "Roles",
    ContentGroupsList: "Content groups",
    DisplayGroups: "Screen groups",
    Displays: "Screens",
    PortalsAgent: "Portals Agent",
    PortalsAgentTablet: "Intercoms",
    PortalAgent: "Portal Agent",
    PortalsClient: "Portals Client",
    PortalsClientCapsule: "Capsules",
    Deployment: "Deployments",
    Styles: "Styles",
    systemAdmin: "Super Admin",
    errorReports: "Error Reporting",
    organizations: "Organizations",
    Creation: "Create & Design",
    Security: "Content permissions",
    Data: "Connect",
    DataSources: "Data sources",
    DeploymentsCount: "Pending deployments",
    DisconnectedCount: "Number of disconnected screens",
    InvitationsCount: "Pending invitations",
    DeployMenu: "Deploy",

    // PaginationList
    nextPage: "NEXT",
    precPage: "PREV",
    goToPage: "Go to page:",
    page: "page",
    sortByName: "sort by name",
    sortByDatecreated: "sort by date",
    sortByEmail: "sort by email",
    Filters: "Filters",

    SortID: "ID",
    SortGroupName: "Group name",
    SortName: "Name",
    SortCodeAgent: "Agent Code",
    SortDateCreated: "Created",
    SortDateModified: "Last edit",
    SortContentType: "Type",
    SortContentGroupName: "Content group",
    SortStatus: "Status",
    SortDisplayGroup: "Screen group",
    SortDateDeployed: "Scheduled",
    SortEmail: "Email",
    SortLastUpdateDate: "Last time the data has changed",
    SortUniqueIdentifier: "Unique ID",
    SortPreview: "Preview",
    SortDeployedBy: "Deployed by",
    SortCreatedBy: "Created by",
    SortModifiedBy: "Modified by",
    SortCurrentDeploymentName: "Last deployment",
    SortCurrentDeploymentDate: "Last deployment date",
    SortSize: "Size",
    SortLastModifiedBy: "Edited by",
    SortDisplayStateUpdate: "Last activity",
    SortApplicationVersion: "Version",
    SortCallCenter: "Call center",
    SortUsers: "Users",
    SortPlayerVersion: "Player",
    SortActions: "Actions",
    SortAction: "Action",
    SortDecisionsTree: "Decision tree",
    SortassociatedPortals: "associated portals",
    SortPortalsClient: "associated Portals Client ",
    SortPortalsAgent: "associated Portals Agent",
    SortZones: "Zones",
    SortZone: "Zone",
    SortOrigin: "Origin",
    SortCategory: "Category",
    SortDuration: "Duration",
    SortDate: "Date",
    SortRole: "Rôle",
    SortAgent: "Agent",
    SortRating: "Rating",
    SortURL: "URL",
    SortDescriptive: "Descriptive",
    SortIndex: "Index",
    SortCallLink: "Call link",

    // MediaGalleryElements
    MediaGallery: "Media Gallery",
    addItem: "Add to schedule",
    removeItem: "Remove from schedule",
    search: "Search",
    remove: "Remove",
    removeTag: "Remove tag",

    // PlaylistElements
    compositions: "Compositions",
    contents: "Contents",
    playlist: "Playlist elements",
    addItemToPlaylist: "Add to playlist",
    removeItemFromPlaylist: "Remove from playlist",
    composition: "Composition",
    content: "Content",
    duration: "00:00:00",
    Duree: "Duration",
    duree: "duration",

    // ScheduleElements
    scheduleElements: "Schedule elements",
    addItemToSchedule: "Add to schedule",
    removeItemFromSchedule: "Remove from schedule",

    // ContentGroupsList
    EditContentGroup: "Edit Content Group",
    newContentGroup: "New Content Group",
    CreateNewContentGroup: "Create new Content Group",
    deleteContentGroup: "Delete Content Group",
    searchByName: "Search by name",
    myGroupName: "New ContentGroup Name",
    helmetContentGroupList: "SKA - Content Groups",

    // EditContentGroup
    Delete: "Delete",
    DeleteAll: "Delete all",
    Close: "Close",
    contentGroupName: "Name",
    permissions: "Permissions list",
    UserGroups: "Organization user groups",
    playlists: "Playlists",
    schedules: "Schedules",
    permissionLabelNone: "None",
    permissionLabelList: "List",
    permissionLabelRead: "Read",
    permissionLabelUpdate: "Update",
    permissionLabelWrite: "Write",
    permissionLabelDelete: "Delete",
    contentGroupMustHaveName: "The Content Group must have a name",
    helmetEditContentGroup: "SKA - Edit ContentGroup",
    deleteNotSaved: "You will be redirected to your library, unsaved modifications will be lost. Do you want to continue ?",
    ok: "OK",

    // Call Log
    helmetCallLog: "SKALink | Call log",
    callLog: "Call log",
    exportDatas: "Export datas",
    ID: "ID",
    CallDetails: "Call details",
    NothingWasNotedByAgent: "Nothing particular was noted by the agent.",
    Attachments: "Attachments",
    ClientAttachments: "Attachments",
    AgentAttachments: "Attachments",
    SendedByClient: "File sended by client",
    SendedByAgent: "File sended by agent",
    ScreenshotByAgent: "Screenshot by agent",
    RecordingByAgent: "Recording by agent",

    // URLCalls
    URLCallsPermanent: "Permanents call link",
    URLRecallClients: "Recall call link",
    helmetURLCalls: "SkaLink | call link",
    helmetURLCallsPermanent: "SkaLink | Permanents call link",
    helmetURLRecallClients: "SkaLink | Client recall call link",
    CallLinkCreated: "Call link created",
    CallLinkSaved: "Call link saved",
    callLinkDeleted: "Call link deleted",
    Programmed: "Programmed",
    Expired: "Expired",
    CreateANewLink: "Create a new link",
    CopiedToClipboard: "Copied to clipboard",
    ModifyLink: "Modify call link",
    CreateLink: "Create call link",
    detailsLink: "Call link details",
    days: "days",
    Target: "Target",
    validity: "Validity",
    ValidFrom: "Valid from",
    At: "At",
    toHour: "to",
    QRCode: "QR Code",
    EndValidationDate: "End of validity of the call link",
    StartValidationDate: "Start of validity of the call link",
    mustHaveCallLinkName: "Call link must have a name",
    SendCallLink: "Send call link",
    TextMessage: "Text Message",
    MobileNumber: "Mobile number",
    NoCallCenterWithThisZone: "No call center with this zone",
    NoCallCenterWithThisUser: "Your user is not associated with a call center",
    textDeleteURLCall: "Are you sure you want to delete this call link?",

    // Carousel
    Advertisement: "Advertisement",
    Carousel: "Carousel",
    Commitment: "Commitment",
    Transition: "Transition",
    Fade: "Fondu",
    Slide: "Slide",
    helmetAdvertisement: "SkaLink | Advertisement",
    helmetCarousel: "SkaLink | Carousel",
    helmetCommitment: "SkaLink | Commitment",
    DisplayingAdvertisements: "Displaying advertisements",
    DownloadTemplate: "Download template",
    AdActivated: "Advertisement activated",
    AdDisabled: "Advertisement disabled",
    NameSlide: "Name slide",
    Button: "Button",
    Without: "Without",
    TextButton: "Button text",
    EditAd: "Edit ad",
    CreateAd: "Create ad",
    ActionButton: "Action button",
    ColorButton: "Color button",
    Black: "Black",
    White: "White",
    Visual: "Visual",
    Impressions: "Impressions",
    Openings: "Openings",
    DeleteAdvertisement: "Remove advertisement ?",
    AlertRemoveAdvertisement: "The deletion of this advertisement and its engagement statistics will be permanent and irreversible.",
    Error: "Error",
    ImpossibleReadImage: "Impossible to read image.",
    IncorrectSize: "Incorrect dimensions",
    ImageMustBeHaveDimensions: "Image must have dimensions  1440px X 2560px",
    youHave: "you have",


    //Call Panel
    TextIntercomUnpaired: "No intercom paired to your count",
    TextIntercomNotConnected: "Your intercom is not connected",
    CR: "Report",
    ShareSend: "Share / Send",
    Control: "Remote control",
    controltitle: "To take remote control of the client's computer:",
    control1: "1. Ask the customer to enable their screen sharing.",
    control2: "2. A window opens with its split screen.",
    control3: "3. Click on \"Mac\" ou \"Windows\" (top right) depending on the operating system used by the customer, then follow the instructions.",
    AttachmentsSendedByClient: "Sended by client",
    AttachmentsSendedByAgent: "Sended by agent",
    MissingInformations: "Missing informations",
    RequiredAction: "Required action :",
    textMissingInformations: "Please assign a call category before closing this call.",

    //CallCenters
    helmetCallCenter: "SkaLink | Call centers",
    CallCenters: "Call centers",
    CallCenter: "Call center",
    allCallCenters: "All call centers",
    CreateNewCallCenter: "Add a call center",
    editCallCenter: "Edit call center",
    callTransfers: "Call transfert",
    callTransfersTo: "Call transfert to :",
    managedZone: "Managed zone",
    openHour: "Open hour",
    exceptionClose: "Exception close day",
    addDate: "Add a date",
    CallTransfersOverThePeriod: "Call transfers over the period",
    Background: "Background",
    ActivateInCall: "Activate in call",
    BadDimensionFile: "Your file is the wrong size",
    TextSizeBackgroundImage: "Your image should be 480px wide and 720px high.",
    closingDay: "Closing day",

    //DecisionTrees
    helmetDecisionTrees: "SkaLink | decision trees",
    DecisionTrees: "Decision trees",
    CreateNewDecisionTree: "Create decision tree",
    CreateTree: "Create tree",
    editDecisionTree: "Edit decision tree",
    Level: "Level",
    addLevel1: "Add entry of level 1",
    addLevel2: "Add entry of level 2",
    addLevelQuestion: "Add a question",
    EditEntry: "Edit entry",
    EditQuestion: "Edit question",
    startLevel1: "Begin to add an entries of first level",
    startLevel2: "Add here your entries of second level",
    Deepness: "Deepness",
    Parameters: "Parameters",
    myName: "My name",
    Information: "Information",
    Text: "Text",
    TextDisplayed: "displayed text",
    File: "File",
    webLink: "Web link",
    callButton: "Call button",
    DefaultCC: "Default CC",
    CompactView: "CompactView",
    CallButtons: "Call Buttons",
    TooltipDimensionsImageDecisionTree: "Recommended dimensions: 1960 x 350 pixels, logo placed in the center (max. width 380 pixels).",
    TooltipDisplayDecisionTree: "Continuously offers the decision tree to the user, even if a Call Center is available.",
    AlwaysShow: "Always Show",

    // CallCategories
    helmetCallCategories: "SkaLink | Call categories",
    CallCategories: "Call categories",
    CreateNewCallCategory: "Create catégory",
    addCallCategory: "Add a call category",
    editCallCategory: "Edit a call category",
    CallCategoriesCreate: "Call categorie created",
    CallCategoriesDeleted: "Call categorie deleted",
    CallCategoriesEdited: "Call categorie edited",

    //EditZones
    Zones: "Areas",
    Zone: "Area",
    helmetEditZones: "SkaLink | Areas",
    CreateNewZone: "Create new area",
    editZone: "Edit zone",
    descriptif: "description",
    confirmDeleteZone: "Delete this zone ?",
    zoneDeleted: "Zone deleted",
    zoneSaved: "Zone saved",
    infoZone: "Zone's informations",

    // EditUserGroup
    userGroupName: "UserGroup name",
    createNewUserGroup: "Create new UserGroup",
    accessRights: "Access rights",
    associatedUsers: "Group members",
    users: "Organization members",
    usersGestion: "Users gestion",
    CreateContentGroup: "New Content Group",
    AccessPlaylists: "Access Playlists",
    DeployPlaylists: "Deploy Playlists",
    AccessContentLibrary: "Access Content Library",
    DeployContent: "Deploy Content",
    AccessSchedule: "Access Schedule",
    DeploySchedule: "Deploy Schedule",
    AccessDisplays: "Access Screens",
    ControlDisplays: "Control Screens",
    ManageDisplays: "Manage Screens",
    ManageOrganization: "Manage Organization",
    CanManageAllContent: "Manage Content",
    CanManageAllPortalClient: "Control Screens",
    helmetEditUserGroup: "SkaLink | Roles",
    disabled: "Disabled",
    scheduleMustHavePLaylist: "this schedule must have a default playlist",
    confirmDeleteUserGroup: "Delete this User Group?",

    // UserGroupsList
    UserGroupsEdit: "Edit User Groups",
    editUserGroup: "Edit User Group",
    newUserGroup: "New User Group",
    rightsGroup: "Rights of this group",
    groupMembers: "Group members",
    CreateNewUserGroup: "Create user Group",
    deleteUserGroup: "Delete User Group",
    newUserGroupName: "New UserGroup Name",
    helmetEditUserGroups: "SKALink | Roles",
    CBPayment: "CB payment",
    CallLinkControlScreen: "Remote control",
    Storage: "Storage",
    Messaging: "Messaging",
    DecisionTreeCallCenterAllotment: "Decision tree ‣ Call center allotment",
    IntercomCallCenterAllotment: "Intercoms ‣ Call center allotment",
    UserCallCenterAllotment: "Users ‣ Call center allotment",
    UserIntercomAllotment: "User ‣ Intercom allotment",
    WithRestrictionOnOrigin: "With restriction on the origin",
    WithCallCenterRestriction: "With call center restriction",
    WithZoneRestriction: "With zone restriction",
    Authorize: "Authorize",
    Consult: "Consult",
    Create: "Create",
    Modify: "Modify",

    //AccessRights
    canManageZone: "canManageZone",
    canManageAllZones: "canManageAllZones",
    canManageAllUsers: "canManageAllUsers",
    canManageZoneUsers: "canManageZoneUsers",
    canManageAllContent: "canManageAllContent",
    canManageAllPortalClients: "canManageAllPortalClients",
    canManageZonePortalClients: "canManageZonePortalClients",
    canManageAllPortalAgents: "canManageAllPortalAgents",
    canManageAllCallCenters: "canManageAllCallCenters",
    canManageAllDecisionTrees: "canManageAllDecisionTrees",

    // EditUser
    blockUser: "Block user account",
    activateUser: "Activate user account",
    userGroups: "User groups",
    ListUsers: "Users list",
    AddUser: "Add user",
    role: "Rôle",
    availableGroups: "Organization groups",
    email: "Email",
    helmetEditUser: "SKA - Edit User",

    // InvitationsList & UsersList
    titleInvitations: "Invitations",
    state: "Statut",
    editUser: "Edit User",
    inviteUser: "Invite User",
    message: "Message",
    assignUserGroup: "Assign to user group",
    firstnameLastname: "Firstname and Name",
    logoutUser: "Logout user ?",
    messageLogoutUser: "If the user is making a call at the time of disconnection, the communication will be immediately interrupted.",
    confirmLogout: "Confirm logout",
    sendDate: "Send date",
    userMail: "User mail",
    invitationDetail: "Invitation detail",

    // InviteUser
    ResentMail: "Send invitation mail",
    invitMessage: "Custom message",
    createNewUser: "Send new Invitation",
    emailNeeded: "a valid email is required to send the invitation",
    helmetInviteUser: "SKA - Invite User",
    invitSuccessfullSave: "This invitation has been successfully saved",
    confirmDeleteInvitation: "Delete this Invitation?",
    invitationDeleted: "Invitation deleted",

    // UserList
    UsersEdits: "Edit Users",
    Accounts: "Accounts",
    AddAccount: "Ajouter un compte",
    searchByEmail: "Search by email",
    CreateNewInvitation: "Add new user",
    deleteInvitation: "Delete Invitation",
    orgaUsers: "Organization users",
    invitations: "Organization invitations",
    helmetUserList: "SkaLink | Users",
    helmetInvitationList: "SkaLink | Invitations",
    displayName: "Displayed name",
    confirmDeleteUserOrg: "Delete this user from the organization?",
    orgUserRemoved: "User deleted.",
    removeUserFromOrg: "Delete user",
    agent: "Agent",

    // Composition -> Settings
    jaliosHero: "Jalios Hero",
    heroMode: "Hero mode",
    noteJaliosHero: "if the selected Media Gallery contains several photos and/or videos, your Hero section will automatically be displayed as a Carousel.",
    defaultImage: "Default image",

    // Composition -> designer
    layoutTitle: "Layout",
    moduleTitle: "Available modules",

    // CompositionsComponents
    kiosk: "Kiosk",

    // CompositionsList
    CompositionsList: "Edit Compositions",
    CreateNewComposition: "New Composition",
    deleteComposition: "Delete",
    searchByTag: "Search by tag",
    helmetEditComp: "SKA - Edit Composition",
    helmetCompositionList: "SKA - Compositions",

    name: "Name",
    dimensions: "Dimensions",
    compositionList: "Compositions list",

    confirmDeleteItemVM: "Delete this message?",
    confirmDeleteItemDescVM: "cette action est irréversible. Vous pouvez télécharger la vidéo contenue dans le message avant de le supprimer.",


    confirmDeleteItemComp: "Delete this composition?",
    confirmDeleteItemDesc: "This action is permanent and cannot be undone",
    textDeleteItem: "Deleting this entry will have an impact on the decision tree and the dispatching of your calls.",
    textDeleteDecisionTree: "the deletion of this decision tree will be final and cannot be undone.",
    confirmDelete: "Confirm delete",
    duplicate: "Duplicate",

    addContent: "Add content",
    removeContent: "Remove content",
    addComposition: "Add composition",
    addPlaylist: "Add playlist",

    // Content Library -> Ads -> Agenda
    fixedPrice: "Fixed price",
    priceOnDemand: "Price on demand",
    makeAnOffer: "Make an offer",
    helmetAds: "SKALINK - Ads",
    YourAdsCategories: "Your Ads categories",
    addACategory: "Add a category",
    addAd: "Add ad",
    aboutItem: "About the item",
    category: "Category",
    callCategory: "Call category",
    coverPic: "Cover pic",
    author: "Author",
    authorEmail: "Author email",
    photos: "Photos",
    upPhotos: "Up to three photos, displayed in addition to the cover pic",
    sales: "Sale",
    price: "Price (€)",
    fullDescription: "Full description",

    // Content Library -> Agenda
    helmetAgenda: "SKALINK - Agenda",
    eventCategories: "Event categories",
    yourEventCategories: "Your Event categories",
    addEvent: "Add an event",
    aboutEvent: "About the event",
    link: "Link",
    from: "From",
    to: "To",
    location: "Location",
    details: "Details",
    shortDescription: "Short description",
    titleDescription: "Title",
    where: "Where",
    address1: "Address #1",
    address2: "Address #2",
    who: "Who",
    speakerNumber: "Speaker #",
    addSpeaker: "Add a speaker",

    // Content Library -> FlipCard
    flipCardVideoImage: "All sides of the flip card must have a video or an image.",
    helmetFlipCard: "SKALINK - Flip Card",
    flipAnimation: "Animation",
    verticalFlip: "Vertical flip",
    flipSides: "Sides",
    flipSideA: "Side A (visible)",
    flipSideB: "Side B (reveal)",

    // ContentsList
    ContentsListEdit: "Edit",
    CreateNewContent: "New content",
    chooseType: "Choose a content type",
    chooseTemplate: "Choose a template",
    contentType: "Type of content",
    contentList: "Contents list",

    confirmDeleteItemContent: "Delete this content?",
    deleted: "Content deleted",
    helmetEditContent: "SKA - Edit Content",
    helmetContentLibrary: "SkaLink | Content Library",

    // Call Link
    sendContent: "Content send",

    //Storage
    helmetStorage: "SkaLink | Storage",
    scanStorage: "Scan",
    scanning: "Scanning",
    scanDone: "Scan done",
    unusedContent: "Unused content",
    storagenoItemsMessageLine1: "Need to free up your storage?",
    storagenoItemsMessageLine2: "Press the SCAN button and discover the purgeable content",
    DeleteSelected: "Delete",
    used: "Used",
    purgeable: "Purgeable",
    manageStorage: "Manage storage",
    local: "Local",
    externalApi: "External APIs",

    // ContentsListPagination
    firstPage: "First Page",
    previousPage: "Previous Page",
    lastPage: "Last Page",

    //StatusNames
    Waiting: "Waiting",
    Cancelled: "Cancelled",
    Processed: "Processed",
    Uploaded: "Uploaded",

    //EditComposition
    CompositionsListEdit: "Edit Compositions",

    edit: "Edit",
    apply: "Apply",

    CommonResolutions: "Common resolutions",
    Width: "Display width",
    Height: "Display height",
    ApplyNewDimensions: "Apply new dimensions",
    availableContents: "Available Contents",

    fullScreen: "full screen",
    exitFullScreen: "exit full screen",

    editContent: "Edit content",
    BringForward: "Bring forward",
    BringToFront: "Bring to front",
    SendBackwards: "Send backwards",
    SendToBack: "Send to back",

    Landscape: "Landscape",
    Portrait: "Portrait",
    switchScreenSize: "Switch dimensions",

    successfullSave: "This Content has been successfully saved",
    successfullSaveDisplay: "This Display has been successfully saved",
    successfullSaveComposition: "This Composition has been successfully saved",

    limitVideoAsset: "There can not be more than one video in this composition.",

    SetFullScreen: "set full screen",
    SetFullHeight: "set full height",
    SetFullWidth: "set full width",
    Dimensions: "Dimensions",
    chooseResizeContent: "do you want to resize the content with the composition? (the content will be removed otherwise)",
    noContentGroup: "You must select a content group for the composition to see this user group contents.",
    Yes: "yes",
    No: "no",
    None: "None",
    Uniform: "Uniform",
    UniformToFill: "Uniform to fill",
    Fill: "Fill",
    Position: "Position",
    stretch: "Stretch",

    NewContent: "New Content",
    SelectedContent: ["You have selected \"", "\" in this composition. Do you wish to replace this object with \"", "\", or to add \"", "\" to the composition ?"],
    Replace: "Replace",
    Add: "Add",

    UseClipLines: "Use clip lines",
    ShowGrid: "Show grid",
    SnapToGrid: "Snap to grid",
    GridInterval: "Grid interval",
    ShowRuler: "Show ruler",

    // Banner
    helmetBanner: "SKA - Edit Banner",

    deleteContent: "Delete content",
    confirmDeleteItem: "Delete this content?",

    autoFont: "font size auto :",
    fontsize: "Font size",
    durationText: "Text duration",
    backgroundColor: "Background color",
    textColor: "Text color",
    yourText: "Your text",

    // Bus
    helmetBus: "SKA - Edit Bus",
    mustBeConnected: "The display must be connected to internet for this content to work.",

    noCitySelected: "No stop point selected",
    labelBus: "Select a stop point",

    mustHaveStopPoint: "Please select a stop point by clicking on a suggestion",

    stationsColor: "Stations color",
    fontsizeTitle: "Title font size",

    selected: "Selected stop point: ",

    // Cita
    helmetCita: "SKA - Edit Cita",
    labelCita: "Choose a cita camera",
    mustHaveCamera: "You must choose a cita camera",
    selectedCamera: "selected camera: ",
    none: "none",
    textColorTitle: "Title text color",
    textFontSize: "Title text font size",

    // Clock
    helmetClock: "SKA - Edit Clock",

    fullLetters: "Full letters",
    shortLetters: "Short letters",
    oneDigit: "One digit",
    twoDigit: "Two digit",

    dayFormat: "Day format",
    monthFormat: "Month format",
    yearFormat: "Year format",

    yearFull: "Full",
    yearShort: "Short",

    day: "Day",
    month: "Month",
    year: "Year",

    helperMonthOneDigit: "June will be: 6",
    helperMonthTwoDigit: "June will be: 06",
    helperMonthFullLetters: "August will be: August",
    helperMonthShortLetters: "August will be: Aug",

    helperDayOneDigit: "The sixth will be: 6",
    helperDayTwoDigit: "The sixth will be: 06",

    helperYearFull: "2018 will be: 2018",
    helperYearShort: "2018 will be: 18",

    separator: "Separator",
    blankSpace: "Blank space",
    timezone: "Timezone",
    hourFormat: "Hour format",

    helperHourFull: "16:30",
    helperHourShort: "4:30 PM",

    // Facebook
    helmetFacebook: "SKA - Edit Facebook",
    facebookLabel: "The url of the facebook page (ex : https://facebook.com/Artnolens/)",
    mustHaveValidKey: "Your url is not valid, only public pages can be used",
    hihlightColor: "Title & dates color",
    primaryColor: "Content color",
    secondaryColor: "Logo color",
    mediumFontSize: "Content font size",
    smallFontSIze: "Title & date font size",
    connectFacebook: "Connect to Facebook",
    descriptionFacebook: "You can only see the Facebook pages of an account you own.",
    selectFacebookPage: "Availables pages",
    noFacebookPages: "No facebook pages available",

    // HTMLContent
    helmetHtmlContent: "SKA - Edit Html Content",
    selectZipFile: "select zip file",
    changeZipFile: "change zip file",
    fileInput: "Select or drop down your file",
    noFileSelected: "No file selected",
    selectedFile: "Selected file: ",
    explainHtmlContent: "Upload your own html content. Zip file must contain a index.html at root.",
    mustHaveFile: "You must select at least one file to proceed",

    loadingGifColor: "loading gif color",

    // Image
    selectImage: "select image",
    changeImage: "change image",
    mustHaveImage: "This asset must have a thumbnail.",
    helmetImage: "SKA - Image",
    helmetPDF: "SKA - PDF",
    uploadInProgress: "Upload in progress, please wait",
    selectPreviewImage: "Change preview image",
    autoGenerated: "Will be auto generated if nothing is selected",

    // Instagram
    helmetInstagram: "SKA - Edit Instagram",
    descriptionInstagram: "You can only see the instagram pictures of an account you own.",
    connect: "Connect to Instagram",
    succesfullyAuthenticated: "You are successfully authenticated as: ",
    waitingToConnect: "Waiting for you to connect to Facebook...",

    // List
    helmetList: "SKA - Edit Table",

    FirstRowAsHeader: "Header style for first row",
    AlternateRowBackground: "Alternate rows background",

    newText: "Your text",
    newTitle: "Title",
    addRow: "add row",
    removeRow: "Remove this row",
    removeColumn: "Remove this column",
    addColumn: "add Column",

    // MediaGallery
    addAsset: "select images",
    changeAsset: "change images",
    addMedia: "ADD A MEDIA",

    helmetMediaGallery: "SKA - Edit Media gallery",
    durationPerItem: "Duration per image (seconds)",
    transition: "Transition",
    fileTooBig: "Your files are too big",
    fileTooBigDesc: "The files must not exceed ",
    defaultTransition: "Default transition",
    defaultDuration: "Default duration",

    // Memory Game
    memoryGameTitle: "Memory Game",
    helmetMemoryGame: "SKALINK - Game · Memory",
    commonFace: "Common face",
    cards: "Cards",

    // JobBoard
    helmetJobBoard: "SKA - Job Board",
    jobBoard: "Job board",
    jobNotDefined: "Not defined",
    jobUnFixedContract: "Unfixed term contract",
    jobFixedContractFullTime: "Fixed term contract · Full time",
    jobFixedContractPartTime: "Fixed term contract · Part-time",
    jobPermanentContractFullTime: "Permanent contract · Full time",
    jobPermanentContractPartTime: "Permanent contract · Part-time",
    jobCategories: "Job categories",
    yourJobCategries: "Your Job categories",
    jobs: "Jobs",
    addJob: "Add a job",
    aboutJob: "About the job",
    contract: "Contract",
    jobDescription: "Job description",
    application: "Application",
    pageURL: "Page URL",
    note: "Note",
    linkToApply: "Insert the link to the Application web page. A QR code will be automatically generated, enabling the candidate to apply directly from its mobile phone.",
    photo: "Photo",
    newSwitch: "Flag as New",

    // PDF Menu
    pdfMenu: "PDF Menu",

    // RSS
    rss: "RSS",
    helmetRSS: "SKA - Edit RSS",
    rssLabel: "URL of your RSS feed",
    mustBeValidUrl: "Your url is not valid",

    // Text
    helmetText: "SKA - Edit Text",
    left: "left",
    right: "right",
    center: "center",
    justify: "justify",
    fontSize: "Font size",
    percent: "%",
    notFound: "404",

    // X (Twitter)
    twitterUser: "X (Twitter) user",
    helmetTwitter: "SKA - Edit X (Twitter)",
    twitterLabel: "The name of the X (Twitter) timeline",
    selectHashtag: "Switch to #",
    selectAt: "Switch to @",
    usernameTwitterNeeded: "A valid X (Twitter) username is required.",
    checkButtonTwitter: "Verify",
    checkedButtonTwitter: "Verified",
    displayBehavior: "Display",
    textVerifiedTwitter: "Mandatory before saving the module",
    xFeedTwitter: "X Feed (Twitter)",
    headline: "Headline",
    latest10Posts: "10 latest posts",
    latest20Posts: "20 latest posts",
    latest50Posts: "50 latest posts",
    latest100Posts: "100 latest posts",
    usernameTwitterExist: "A twitter with this username already exist within your contents.",

    // Video
    selectVideo: "select video",
    changeVideo: "change video",
    helmetVideo: "SKA - Video",
    isMute: "Mute sound",

    // Weather
    helmetWeather: "SKA - Edit Weather",
    mustHaveCity: "Please select a city by clicking on a suggestion",
    showForTheDay: "Show broadcast for the day",
    showForTheWeek: "Show broadcast for the week",
    primaryColorWeather: "Title and temperature color",
    secondaryColorWeather: "Secondary informations color",
    backgroundColorWeather: "Background color",
    FullScreen: "All infos and previsions",
    NormalScreen: "Critical infos and previsions",
    Banner: "Banner with critical infos and previsions",
    MinifiedScreen: "Only critical infos",

    // WebURL
    helmetWebURL: "SKA - Web URL",
    webURL: "webURL ex: http://www.inui-studio.com/",
    mustHaveUrl: "this content must have an URL",

    // Youtube
    helmetYoutube: "SKA - Edit Youtube",
    key: "Youtube url (ex : https://www.youtube.com/watch?v=WV_CJCWQYY0 )",
    mustHaveValidKeyYoutube: "this content must have a correct Youtube url",

    // DataSourcesList
    helmetDataSourcesList: "SKA - Data sources",
    CreateNewDataSource: "New data source",

    confirmDeleteDataSource: "Delete this data source ?",
    confirmDeleteDataSourceDesc: "This action is permanent and cannot be undone",
    chooseTypeDataSource: "Choose data source type",

    // TableDataSource
    helmetTableDataSource: "SKA - Edit data source",
    titleDataSource: "Table data source",
    dataSourceName: "Name",

    // TextDataSource
    helmetTextDataSource: "SKA - Edit data source",
    titleTextDataSource: "Text data source",

    // DeploymentList
    DeploymentList: "Deployment planner",
    helmetDeploymentList: "SKA - Deployments",
    history: "Deployments list",
    newDeploy: "New deployment",

    scheduleDeploy: "Schedule",
    screen: "Screens",
    compo: "Compos°",

    DeploymentStatus: "Status",
    DeploymentDate: "Deployment date",
    DeploymentType: "Type",
    DeploymentGroup: "Content group",
    ShowScheduleCalendar: "Show schedule calendar",
    numberOfDeployedScreens: "Number of deployed screens / number of screens in the group",

    DisplayGroup: "Display group",
    Schedule: "Schedule",
    Date: "Date",
    lang: "en-EN",
    of: " of ",

    // NewDeployment
    helmetNewDeployment: "SKA - New deployment",
    Deploy: "Deploy",
    TargetedDisplayGroups: "Targeted display groups",
    organizationDisplayGroups: "Organization display groups",
    schedule: "Schedule to deploy",
    mustHaveDisplayGroup: "You must select at least one display group",
    ExpectedDeploymentDate: "Expected deployment date",

    // Login
    doyouwisthToLogin: "Do you wish to Log in?",
    login: "Login",
    welcome: ", welcome to SKA",
    noOrganisation: "You need to be invited to at least one organization before going further.",
    organization: "Current organization : ",
    home: "Home",
    helmetLogin: "SkaLink | Welcome",

    // containers -> Home
    click: "Click",

    // Dashboard
    helmetDashboard: "SkaLink | Dashboard",
    chooseZone: "Choose zone",
    period: "Périod",
    sessionsCardTitle: "sessions",
    infosReportSessions: "36% of sessions generated calls",
    calls: "calls",
    call: "call",
    lost: "lost",
    callHandledCardTitle: "Calls Handled",
    callLostCardTitle: "Calls Lost",
    durationCallCardTitle: "Average duration",
    durationSumCallCardTitle: "Sum duration",
    satisfactionClient: "Client satisfaction",
    SatisfactionClientAverage: "Client Satisfaction (ave.)",
    infosReportDurationCall: "Average over 139 calls",
    noRating: "No rating",
    ContinuousModeTransitions: "Continuous mode transitions",
    ListOfEvents: "List of events",
    lostCalls: "lost calls",
    AverageOn: "Average on ",
    Average: "Average",
    average: "average",
    Avg: "Avg.",
    avg: "avg.",
    total: "total",
    Total: "Total",
    TotalCall: "Total calls",
    IntercomName: "Nom de l'Intercom",
    overThePeriod: "over the period",
    OverThePeriod: "Over the period",
    ofCalls: "of calls",
    totalOverThePeriod: "Total over the period",
    TreatedBy: "Treated by",
    By: "By",
    To: "To",
    the: "the",
    Jours: "Days",
    Timings: "Horaires",
    DistributionOf: "Distribution of",
    weekdayCalls: "weekday calls",
    byTimeSlots: "by time slots",
    Categories: "Categories",
    DisponibilityClients: "Disponibility Clients",
    DisponibilityAgents: "Disponibility Agents",
    Sujets: "Subjects",
    AbsentMode: "Absent mode",
    DisturbedSituations: "Disturbed situations",
    TotalTimeInAbsentModeByIntercom: "Total time in absent mode, by intercom",
    inAbsentMode: "in absent mode",
    AllZones: "All origins",

    // CallLink
    helmetCallLink: "SkaLink | Call Link",
    client: "Client",
    treatedbyat: "Treated by / when",
    company: "Company",
    contact: "Contact",
    notDefined: "Not defined",
    DefineCateg: "définir une catégorie...",
    selectContent: "Sélect content",
    URLCalls: "Call links",
    CallApp: "CallApp",
    TargetCA: "Target CA",
    LinkValidity: "Link validity",
    Sharescreen: "Share screen",
    ClientSharescreen: "Client share screen",
    MyComputerScreen: "My computer screen",
    Payment: "Payment",
    AskingForConsent: "Asking for consent",
    ConsentRequestSent: "Consent request sent",
    ConsentGranted: "Consent granted",
    DescriptionConsentGranted: "The customer has given his consent for the transmission and use of his bank card data in the context of his request.",
    ConsentRefused: "Consent refused",
    DescriptionConsentRefused: "The customer has not given his consent for the transmission and use of his bank card data in the context of his request.",
    SendingContent: "Sending content",
    FromMyComputer: "From my computer",
    Resource: "Resource",
    Notes: "Notes",
    DescriptionNotes: "Indicate how the customer was encouraged to use the device, other useful information, etc.",
    FileSentByClient: "File sent by the client",
    FileSentByIntercom: "File sent by the intercom",
    FileSentByPilot: "File sent by the pilot",
    VideoRecorded: "Video recorded",
    VideoRecordedIntercom: "Video recorded from intercom",
    TextParingCodeLine1: "Enter the verification code sent by the customer.",
    TextParingCodeLine2: "After validation, the remote control can start.",
    ErrorTextParingCodeLine1: "Invalid verification code. Please check your entered digits and try again.",
    ErrorTextParingCodeAlreadyUsedLine1: "This verification code is already associated with an ongoing screen capture. Please check your digits and try again.",
    StartRemoteControl: "Start the takeover",
    ControlClientComputer: "Control the customer's computer",
    allAttachments: "All attachments",
    noAttachment: "There is no attachment for this moment.",

    // WaitingList
    helmetWaitingList: "SkaLink | Waiting list",
    WaitingList: "Waiting list",
    personsWaiting: "persons waiting",
    TotalNumberOfPeopleWaiting: "Toral number of people waiting",
    Mobile: "Mobile",
    Computer: "Computer",
    Capsule: "Capsule",
    WaitTime: "Wait time",
    Device: "Device",
    activeFlux: "active flux",

    welcomeDashboard: "Welcome",
    todayStats: "TODAY",
    monthStats: "30 DAYS",
    cumulatedSessions: "Cumulated sessions",
    on: "on",
    updatedHour: "Updated at ",
    sessionsOn: "Sessions on ",
    top5Kiosk: "Top 5 best-performing Kiosks",
    top5Content: "Top 5 best-performing Contents",
    sessions: "Sessions",
    sessionsDay: " · Day by day",
    sessionsHour: " · Breakdown by time slot",
    moduleOpenings: "Modules openings",
    modulesDay: " · By day",
    modulesHour: " · Breakdown by time slot",
    top10Kiosk: "Top 10 best-performing Kiosks",
    top10Module: "Top 10 best-performing Modules",

    // VideoPlayer
    PreviewUnavailable: "Preview unavailable.",

    // DisplayGroupsList
    DisplayGroupsList: "Edit Screen Groups",
    CreateNewDisplayGroup: "Create new Screen Group",
    deleteDisplayGroup: "Delete Screen Group",
    newDisplayGroupName: "New ScreenGroup Name",
    helmetDisplayGroupList: "SKA - Screen Groups",
    newScreenGroup: "New Screen Group",
    about: "About",

    // EditDisplayGroup
    EditDisplayGroup: "Edit Screen Group",
    helmetEditDisplayGroup: "SKA - Edit ScreenGroup",
    contentToDIsplay: "Content to display",
    currentDisplays: "Group screens",
    allDisplays: "Organization screens",
    alertName: "the screen group must have a name",
    changeSaved: "Successfully saved",
    descriptionLabel: "Description",
    editDisplay: "edit display",

    // DisplayList
    helmetPortals: "SkaLink | Portals",
    helmetPortalAgent: "SkaLink | Portals agent",
    helmetPortalClient: "SkaLink | Portals client",
    DisplaysList: "Edit Screens",
    editScreen: "Edit Screen",
    CreateNewDisplay: "Add new portal Client",
    CreateNewPortalAgent: "Add intercom",
    editIntercom: "Edit intercom",
    editCapsule: "Edit capsule",
    SizeCapsule: "Size Capsule",
    inch: "inch",
    infoIntercom: "Intercom's informations",
    infoCapsule: "Capsule's informations",
    deleteDisplay: "Delete Display Group",
    helmetDisplayList: "SKA - Screens",
    screenGroup: "Screen group",
    newIntercom: "New intercom",
    newCapsule: "New capsule",
    hisDescritif: "His descriptif",
    lastCall: "Last call",
    ShowAllLogs: "Show all logs",
    NoLogsInStorage: "No log in storage",
    CallInProgress: "Call in progress",
    OffLine: "Offline",
    BreakMode: "Break mode",
    SleepMode: "Away mode",
    ByDefault: "by default",
    Available: "Available",
    IncomingCall: "Incoming call",
    NoStatus: "No status",
    StatusCapsule: "Capsule status",
    StatusIntercom: "Intercom status",
    MessageStatusAvailableCapsule: "Choose this status for the capsule to function normally.",
    MessageStatusAvailableIntercom: "Choose this status for the intercom to function normally.",
    MessageStatusSleepModeCapsule: "The capsule displays a message informing users that the service is unavailable.",
    MessageStatusSleepModeIntercom: "The intercom is no longer able to receive calls.",

    // CallApp
    ActiveWebcalls: "webcalls actifs",

    // EditDisplay
    displaysList: "Screens",
    addDisplay: "Add display",
    EditDisplay: "Edit Display",
    helmetEditDisplay: "SKA - Edit DisplayGroup",
    CreateDisplay: "Create new display",
    SaveModif: "Save modifications",
    alertType: "The display must have a Display Type",
    alertCode: "The display must have an identification code",
    alertContent: "The display must be linked to a display group",
    identificationCode: "Identification code",
    displayType: "Display Type",
    screenMonitoring: "Screen monitoring",
    displayGroups: "Screen groups",
    hide: "Hide on display",
    show: "Show on display",
    sendLogs: "LOGS",
    sendInfos: "INFOS",
    status: "Display status ",
    securityLock: "Security Lock",
    restart: "Restart display",
    powerOff: "Shut down display",
    mute: "Mute display",
    unmute: "Unmute display",
    volumeUp: "Volume up",
    volumeDown: "Volume down",
    getScreenShot: "Get ScreenShot",
    timerScreenShot: "A new screenshot of the display will be available in a few minutes.",
    getScreenStream: "Stream display",
    getScreenStreamdetailed: "Get one screenshot every 5 seconds for 1 min.",
    noScreenShot: "This display has not taken any screenshot yet.",

    securityunLock: "Security unLock",
    VOL: "VOL",
    MUT: "MUT",
    SEC: "SEC",

    downloadLogFile: "Download log file",
    logFileReadyToDownload: "Log file ready to download",

    waitingForLogs: "Waiting for logs...",
    showLiveLogs: "Show live console",
    showLiveScreen: "Show live screenshot",
    displayLocation: "Location",

    // Not Found
    pageNotFound: "Page not found",

    // Playlist
    CreatePlaylist: "Create a Playlist",
    helmetPlaylist: "SKA - Create a Playlist",
    confirmDeletePlaylist: "Delete this playlist?",
    confirmDeletePlaylistDesc: "This action is permanent and cannot be undone",

    // PlaylistList
    helmetPlaylists: "SKA - Playlists",
    CreateNewPlaylist: "Create new playlist",

    // AdvancedSchedules
    helmetSchedules: "SKA - Schedules",
    defaultPlaylist: "Default playlist",
    defaultPlaylistHelp: "Playlist that will play when nothing is selected",

    previewNotAvailable: "Preview not available for advanced schedule",

    style: "Schedule style",
    default: "Default",
    chooseStyleSchedule: "Choose schedule style",
    choosePlaylist: "Select schedule playlists",
    SchedulePlaylists: "Schedule Playlists",
    OrganizationPlaylist: "Available playlists",

    Playlist: "Playlist",
    End: "End",
    allDayEvent: "All day event",
    Repeat: "Repeat",
    Description: "Descriptif",

    // BasicSchedule
    CreateSchedule: "Create a Schedule",
    confirmDeleteSchedule: "Delete this schedule?",
    confirmDeleteScheduleDesc: "This action is permanent and cannot be undone",

    // SchedulesList
    helmetSchedulesList: "SKA - Schedules",
    CreateNewSchedule: "New schedule",
    CreateNewAdvancedSchedule: "Create new advanced schedule",
    advancedScedule: "Advanced",
    basicSchedule: "Basic",
    AdvancedScheduleDescription: "You will quickly deploy one or more playlists that will play as an infinite loop.",
    CreateNewBasicSchedule: "Create new basic schedule",
    BasicScheduleDescription: "Deploy one or more playlists that will play as an infinite loop.",

    advanced: "Calendar",
    basic: "Basic",

    // Search
    helmetSearch: "Search page",
    selection: "Tags ",
    otherInfos: "other informations",
    Search: "Search",
    SearchComingSoon: "Search",

    // Style
    hello: "Hello, world!",
    helmetStyle: "SKA - Styles",
    titleStyles: "Styles",
    deleteStyle: "Delete style",
    confirmDeleteStyle: "Delete this style?",
    confirmDeleteStyleDesc: "This action is permanent and cannot be undone",
    styleDuplicated: "New style created",

    ApplicationFontFamily: "ApplicationFontFamily",

    ApplicationBackgroundColor: "Compositions background",
    PrimaryBackgroundColor: "Content background",
    SecondaryBackgroundColor: "Alternate content background",
    HighLightColor: "Hilighted text color",
    PrimaryColor: "Normal text color",
    SecondaryColor: "Alternate text color",

    BigTextFontSize: "Title font size",
    MediumTextFontSize: "Normal text font size",
    SmallTextFontSize: "Smaller text font size",

    EditContentStyleDialog: [
        "You will be prompted to choose a style to be applied on your content",
        "at scheduling & deployment time.",
        "Alternatively, you can decide to apply a fixed theme to this particular content so that scheduling & deployment style will be ignored for this particular content.",
        "Sart editing the following values by your own, or ",
        "import values from your styles library."
    ],

    inheritedStyle: "Unchanged, deployment style will be used",
    overridedStyle: "Overriden !",
    import: "Import",

    // StylesList
    helmetStyles: "SKA - Styles",
    CreateNewStyle: "Create new style",

    // ErrorReport
    helmetErrorReport: "Error reports",
    source: "Source: ",
    browser: "Browser: ",
    user: "User ",
    exception: "Exception: ",
    date: "Date: ",
    url: "Url: ",
    options: "Options: ",
    localStorage: "Local storage: ",
    navigator: "Navigator",
    statusCode: "Status Code",
    sourceError: "Source",
    creatorError: "Creator",
    dateError: "Date",
    statusError: "Status",

    // ErrorReportList
    helmetErrorReports: "SKA - Error reports",

    // Organization
    titleOrg: "Create organization",
    helmetOrg: "SKA - Create organization",

    organizationName: "Organization Name",
    organizationAdminEmail: "Email administrator",

    mustHaveOrgName: "Organization must have a name",
    mustHaveOneEmail: "Organization must have at least one admin",
    emailMustBe: "One or more email address is not valid",
    isDisabled: "Disabled",

    // Super Admin
    helmetSuperAdmin: "SkaLink | Super Admin",

    // OrganizationList
    CreateNewOrg: "Create new Organization",
    helmetOrganization: "SkaLink | Organizations",

    organizationList: "Organization list",

    enableOrg: "Enable this organization?",
    Enable: "Enable",

    confirmDisableItem: "Disable this organization?",
    confirmDisableItemDesc: "All users won't be able to do anything in this organization",
    confirmDisable: "disable",

    // LoginCallback
    loggingIn: "Logging in",

    compositionIsVisibleLabel: "Is visible",
    compositionPreviewLabel: "Preview",
    compositionDescriptionLabel: "Description",

    languageName: "Language Name",
    languageCode: "Language Code",
    languageCheckDefault: "Checked by default",

    organizationSaved: "Organization saved!",

    nodeName: "Node Name",
    nodeParameters: "Node Parameters",
    maxDepth: "Max Depth",

    compositionParameters: "Parameters",
    compositionTitle: "Title ",
    compositionDescription: "Description ",
    compositionIsVisible: "Is Visible",
    compositionKiosk: "Libraries",

    parameterName: "Parameter Name",
    parameterDisplayName: "Parameter display name",
    defaultValue: "Default value (optional)",
    compositionType: "Type",

    string: "String",
    int: "Integer",
    dateTime: "Date",
    time: "time",
    times: "times",
    urlOrganization: "Url",
    FormOrganization: "Form",
    textOrganization: "Text",
    tableOrganization: "Table",
    contestOrganization: "Contest",

    languages: "Languages",
    playerUI: "Player UI",
    OrganizationParameters: "Organization parameters",
    OrganizationFiles: "Organization files",
    chooseFile: "Choose file",
    OrganizationModules: "Organization modules ( among : ",
    compositionConfig: "Composition config",
    compositionParameter: "Composition parameters",
    compositionDefaultTree: "Composition default tree",
    compositionDefaultTreeAvailable: "Composition default tree (available after save)",
    newOrganization: "New Organization",
    Users: "Users",
    administrators: "Administrators",

    selectPDF: "SELECT PDF",
    changePDF: "CHANGE PDF",

    onlyOneFilePDF: "You must drop only 1 pdf file or 1 image file for the preview",
    onlyOneFile: "You cannot drop multiple file for this content type",
    dropFileFromYourComputer: "You must choose a file from your computer",
    unsupportedFileFormat: "Unsupported file format",

    SortLangs: "Langs",

    captureFrame: "Capture frame",

    dateCantBeInThePast: "The deployment date can't be in the past!",

    unexpectedError: "An unexpected error occured",
    unexpectedErrorDescription: "Refresh the page or contact us to solve the problem",
    refreshPage: "Refresh Page",

    ImportFiles: "Import Files",
    ImportFilesTitle: "Import files",
    AddWebLink: "Ajouter un lien web",
    titleErrorImportFiles: "⚠️ Unsupported file format",
    errorImportFiles: "SKA does not accept this type of file. Please import a supported format such as .jpg / .jpeg / .png / .pdf or .mp4.",
    browseFiles: "browse",
    UploadManager: "Import in progress",
    uploadManagerInProgress: "In Progress",
    uploadManagerQueue: "Queue",
    uploadManagerDone: "Done",
    processing: "Processing",
    uploadDownloaded: "Downloaded",
    uploadWaiting: "Waiting",
    uploadManagerWait: "Please wait, this can take a while",
    assignTheUpload: "Assign to the content group:",
    confirmUpload: "confirm upload",
    generatingThumbnails: "Generating Thumbnails",
    addMore: "add more",

    appProtocol: "Application Protocol",
    isRequired: "Is Required",
    isRequiredDesc: " is required.",
    TheParameter: "The parameter ",
    mustBeAValidUrl: " must be a valid URL.",

    mustHaveComposition: "You must select a composition",
    chooseDisplayGroup: "Choose a Display Group",

    noItems: "No item yet",

    createContent: "New Content",

    maxDisplayNumber: "Nombre de display max (licenses)",

    compositionModules: "Organization modules",
    compositionModulesSeparator: "(separator: \";\")",
    compositionModuleRates: "Rates",
    compositionModuleQuestionForm: "Question Form",

    invalidValueFloat: "The value must be a number.",

    askForContactInformation: "Ask for contact information",
    goToNextQuestionAuto: "Automatically navigate to the next question",
    questionFormTitle: "Question form title",

    questionTitle: "Question",
    questionType: "Question type",
    questionTypeSingleSelection: "Single selection",
    questionTypeMultiSelection: "Multi selection",
    questionTypeNumeric: "Numeric",
    questionTypeDate: "Date",
    answer: "Answer",
    answerValue: "Answer value",
    removeAnswer: "Remove answer",
    addAnswer: "Add answer",
    removeQuestion: "Remove question",
    addQuestion: "Add a question",

    questionDefaultValue: "Default value",
    minValue: "Min value",
    maxValue: "Max value",
    moveUp: "Move up",
    moveDown: "Move down",

    compositionModuleLibrairiesParameters: "Libraries parameters",
    banner: "Banner",

    // Survey
    survey: "Survey",
    Forms: "Surveys",
    formsTitle: "Forms",
    CreateNewForm: "New survey",
    helmetFormsList: "SKA - Surveys",
    successfullSaveForm: "This Form has been successfully saved.",
    formDuplicated: "New survey created",
    confirmDeleteForm: "Delete this survey?",
    formDeleted: "Form deleted",
    addForm: "Add survey",
    addQuizz: "Add quizz",
    chooseForm: "Choose a survey",
    quizzMode: "Quizz mode",
    noteQuizzMode: "Note: when the Quizz mode is enabled, the survey delivers an end message related to the user's score.",
    successScore: "Success score",
    thanks: "Thanks",
    inCaseOfSuccess: "In case of success",
    MessageAtEnd: "Message at the end",
    InCaseOfFail: "In case of fail",
    tagline: "Tagline",
    body: "Body",
    addAnOption: "Add an option",

    questionForm: "Questions",
    responses: "Responses",
    formStyle: "Style",

    averageTimeToAnswer: "Average time to complete",
    totalAnswers: "Total answers",
    noResponsesYet: "No one has answered the questionnaire yet!",

    exportToCSV: "Export to CSV",

    treeHasModified: "Please save the composition to edit the parameters.",

    backToMenu: "Back to menu",
    addDataSource: "Add Data source",

    homepageDesigner: "Homepage designer",
    navigationMenuDesigner: "Navigation Menu Designer",

    appointementRestriction: "Appointement restrictions",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    Morning: "Morning",
    Afternoon: "Afternoon",

    // Contest
    Contests: "Contests",
    contestDeleted: "Contest deleted",
    contestDuplicated: "Contest duplicated",
    helmetContestsList: "SKA - Contests",
    CreateNewContest: "Create new contest",
    participations: "Participations",
    contestDetails: "Details",
    contestStartDate: "Contest start date",
    contestEndDate: "Contest end date (optional)",
    mustHaveStartDate: "this contest must have a start date",
    successfullSaveContest: "The contest has been successfully saved.",
    confirmDeleteContest: "Delete this Contest?",
    addContest: "Add Contest",
    chooseContest: "Choose a contest",
    firstName: "First Name",
    lastName: "Last Name",
    score: "Score",
    phone: "Phone",
    participationDate: "Participation Date",
    ratesFileFormat: "The file is not in the correct format",

    // HomeDesigner
    pages: "pages",
    createNewPage: "add a page",
    removeLastPage: "remove last page",
    selectPageBackground: "page background",
    defaultLayout: "default layout",
    selectModulePreview: "preview",
    selectModuleContent: "displayed content",
    selectModuleDataSource: "displayed survey",
    fillLayout: "fill layout",
    imageInput: "select preview",

    //Drugstores
    drugstoresTitle: "Drugstores",
    drugstoresDescription: "A list of open drugstores in Luxembourg",
    hero: "Hero",
    changeHero: "Replace",
    selectHero: "Select",

    //Agenda
    agendaTitle: "Agenda",
    agendaDescription: "The list of your upcoming events with description & QR Code for registration.",
    agendaEvents: "Events",
    agendaSubtitle: "Subtitle ",
    selectCategory: "Change category name",
    addCategory: "Create New",
    allCategory: "Categories",
    newCategorie: "New categorie",

    //Directory
    directoryTitle: "Directory",
    directoryDescription: "The people of your company, listed thematically with contact details",
    helmetDirectory: "SKA - Directory",
    memberCategories: "Member categories",
    people: "people",
    addPeople: "Add people",
    emailAddress: "Email address",
    linkedin: "Linkedin",

    //PDF Library
    helmetPDFLibrary: "SKA - PDF Library",
    pdflibraryTitle: "PDF Library",
    pdflibraryDescription: "A collection of .pdf documents (single page or multipage).",
    startPublicationDate: "Start publication date",
    endPublicationDate: "End publication date",
    fileAttributes: "File Attributes",
    availability: "Availability",
    documentCategories: "Document categories",
    PDFCategories: "PDF categories",

    //E-reider
    helmetEReider: "SKA - E-Reider",
    pdfEReiderTitle: "E-Reider",
    WPReiderTitle: "WP Reider",
    EReiderDescription: "Your official publications organized into categories and available for download.",

    // Pharmacy
    pharmacyTitle: "Pharmacy",
    pharmacyDescription: "The list of the pharmacies in Luxembourg, with their adresses.",
    typePharmacy: "City",

    //Map
    mapTitle: "Map POI",
    mapDescription: "A map with points of interest such as bus stops, shared mobility & traffic info.",
    mustHaveCenterCoordinates: "You must specify the map center coordinates",
    mapCenterCoordinate: "Map center point",
    mapshowBycicles: "vel'OH",
    mapshowCameras: "Motorway cams",
    mapshowBus: "Public transports",
    mapPOICoordinates: "POI coordinates",
    newPOIGroup: "New POI Group",
    newPOI: "New POI",
    title: "Title",
    caption: "Caption",
    latitude: "Latitude",
    mapDisplaySettings: "Map display settings",
    zoomLevel: "Zoom Level",
    level: "Level",
    carsLocationStations: "Cars location stations",
    addGroupPOI: "Add a group of POI",
    POIGroupSettings: "POI group settings",
    groupName: "Group name",
    groupTitle: "Group title",
    groupIcon: "Group icon",
    listeMap: "List",
    addPOI: "Add a POI",
    modifyPOI: "Modify POI",

    // Itinerary
    itinerary: "Itinerary",

    // News feeds
    newsFeed: "News Feed",

    // WP News
    WPNewsTitle: "WP News",
    WPNewsDescription: "Your News feed synchronized from Wordpress and updated daily.",

    // Jalios
    jaliosPhotoGallery: "Jalios Photo Gallery",
    jaliosAgenda: "Jalios Agenda",

    // Jalios Agenda
    helmetJaliosAgenda: "SKALINK - Jalios Agenda",
    mustHaveImageCategorie: "This asset must have category images.",

    //Mission4
    mission4Title: "Game · Mission4",
    mission4Description: "The mission is simple: be the first to line up four tokens in a row to win!",

    //News
    newsTitle: "News",

    //CustomNews
    custoNewsTitle: "CustomNews",
    custoNewsDescription: "Show your headlines directly on your Homepage",

    displayParameters: "Display Parameters",
    actions: "Actions",

    // Arendt Event categories
    ArendtInternalEvents: "Arendt internal events",
    ArendtClientsEvents: "Arendt clients events",
    ArendtEventsHosted: "External events hosted in Arendt House",
    ArendtSponsoring: "Sponsoring",
    ArendtTraining: "Training",
    ArendtRecruitment: "Recruitment"
};

export default lang;
